<template>
  <el-table
    :data="tableData"
    ref="table"
    border
    size="mini"
    height="560"
    show-summary
    :summary-method="getSummaries"
    style="overflow: visible"
  >
    <el-table-column
      property="rowNum"
      label="序号"
      align="center"
      width="50"
    ></el-table-column>
    <el-table-column
      property="videoTitle"
      label="课件资源名称"
      align="center"
      min-width="150"
    ></el-table-column>
    <el-table-column
      property="videoType"
      label="类型"
      align="center"
      width="80"
    ></el-table-column>
    <el-table-column
      property="finishStatus"
      label="学习情况"
      align="center"
      width="110"
    ></el-table-column>
    <el-table-column
      property="learnTime"
      label="学习时长（累计）"
      align="center"
      width="130"
    ></el-table-column>
    <el-table-column
      property="learnTime"
      label="考核认定时长"
      align="center"
      width="130"
    ></el-table-column>
  </el-table>
</template>

<script>
import * as api from '@/api/learningOutcome/learningOutcome'
export default {
  props: ['courseScoreId'],
  data() {
    return {
      tableData: [],
    }
  },
  created() {
    this.getCourseScoreInfo()
  },
  updated() {
    this.$refs.table.doLayout()
    const tds = document.querySelectorAll('.el-table__footer-wrapper tr>td')
    tds[0].style.display = 'none'
    tds[1].style.display = 'none'
    tds[2].style.display = 'none'
    tds[3].colSpan = 4
    tds[3].style.textAlign = 'right'
    tds[3].style.fontWeight = '700'
  },
  methods: {
    getCourseScoreInfo() {
      api
        .getCourseScoreInfo({
          courseScoreId: this.courseScoreId,
          infoStatus: 0,
        })
        .then((data) => {
          const { code, data: list, msg } = data.data
          if (code === 100000) {
            this.tableData = list.result
          } else {
            this.$message.error(msg)
          }
        })
    },
    timestampTotime(data) {
      const time = Number(data)
      const h = Math.floor(time / 3600)
      const m = Math.floor((time % 3600) / 60)
      const s = parseInt(time % 3600) % 60
      const hh = h < 10 ? '0' + h : h
      const mm = m < 10 ? '0' + m : m
      const ss = s < 10 ? '0' + s : s
      return hh + ':' + mm + ':' + ss
    },
    timeTotimestamp(time) {
      if (time !== null) {
        const [hour, min, sec] = time.split(':')
        return Number(hour * 3600) + Number(min * 60) + Number(sec)
      }
    },
    getSummaries({ columns, data }) {
      let learnTime = 0
      data.forEach((item) => {
        if (item.learnTime) {
          learnTime += this.timeTotimestamp(item.learnTime)
        }
      })
      learnTime = this.timestampTotime(learnTime)
      return ['', '', '', '总时长：', learnTime, learnTime]
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-table__footer-wrapper tbody td,
.el-table__header-wrapper tbody td {
  background-color: #fff;
}
</style>